export default {
  AnonymousInformation__ADD_RAPID_REWARDS_ACCOUNT: "Add my Rapid Rewards^^®^^ account",
  AnonymousInformation__LOGIN_HEADING: "Rapid Rewards^^®^^ login",
  AnonymousInformation__LOGIN_SUBHEADING:
    "Enhance your booking experience and become a registered SWABIZ^^®^^ traveler by logging in with your Rapid Rewards^^®^^ account.",
};
